<template>
  <div>
    <label>
      {{ idLabel }}
      <i v-if="statusIcon !== ''" class="icon icon-transaction-detail"
        v-bind:class="statusIcon">
      </i>
    </label>
    <input class="form-control inputAccordionForm" type="number" disabled="true" v-if="inputType === 'number'"
      :value="inputValue">
    </input>
    <input class="form-control inputAccordionForm" type="text" disabled="true" v-else
      :value="inputValue">
    </input>
    <!-- Le slot par défaut pour afficher certains boutons comme le "View Transfer Order File" -->
    <slot></slot>
  </div>
</template>
<script>
/* @author TLV 24/06/2020
* @brief Component qui affiche les form-groups sur les détails d'une request (accès en lecture)
* @details Ce component a été créé pour permettre de modifier plus rapidement le visuel de ceux-ci si besoin
* @param idLabel demande l'id du label
* @param inputValue demande la valeur à afficher dans l'input
*/
export default {
  name: 'formReadGroupLabelInput',
  props: {
    idLabel: {
      type: String
    },
    inputValue: {
      type: String
    },
    statusIcon: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    }
  }
}
</script>



// WEBPACK FOOTER //
// formReadGroupLabelInput.vue?1f947d5f